import { INITIAL_STATE as INITIAL_STATE_FILTER } from 'constants/traceability.constants'
import { get } from 'lodash'

import { types } from './Box.actions'

const INITIAL_STATE = {
  filterBoxes: INITIAL_STATE_FILTER,
  boxes: {
    items: null,
    pagination: {}
  }
}

function setBoxes(state) {
  return function _handle(payload: Record<string, any>) {
    return { ...state, ...payload }
  }
}

export default function _reducer(state = INITIAL_STATE, { type, payload }) {
  const _handlers = {
    [types.SET_BOXES]: setBoxes(state),
    [types.SET_FILTERS_BOXES]: setBoxes(state),
    [types.CLEAN_BOXES]: setBoxes(INITIAL_STATE),
    _default: () => state
  }

  return get(_handlers, type, _handlers._default)(payload)
}
